export const CATS = [
  "Financial Planners",
  "Mortgage Advisers",
  // "Qualified in both Financial Planners & Mortgage Advisers",
  "GI/Protection Advisers",
  "NAP",
  "Equity Release",
];

